const viewport = document.querySelector('.layout--viewport');
let opener = null;

if (viewport) {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('.header--root [data-drawer-open], .product-buy-buttons--primary, .product-quick-add--button');
    if (control) opener = document.activeElement?.closest('[data-mb-bar-buy]') || control;
  }, true);

  new MutationObserver(() => {
    if (viewport.dataset.drawerStatus !== 'closed' || !opener) return;
    const target = opener;
    opener = null;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const current = document.activeElement;
      const focusLost = current === document.body || current === document.documentElement || current?.closest('.drawer--root');
      if (focusLost && target.isConnected && target.getClientRects().length && !target.disabled) target.focus({preventScroll: true});
    }));
  }).observe(viewport, {attributes: true, attributeFilter: ['data-drawer-status']});
}
